function AddToBagGrid(e) {
  var a = e;
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      id: a,
      quantity: "1",
    },
    success: function () {
      jQuery(".js-drawer-open-button-right").trigger("click");
    },
  });
}

jQuery(function () {
  "true" == jQuery("#site-header").attr("data-flush-header")
    ? jQuery("#PageContainer").addClass("flush--enabled")
    : jQuery("#PageContainer").addClass("flush--disabled"),
    jQuery("#annoucement__bar").hasClass(
      "annoucement__bar--true scroll--true"
    ) &&
      "true" == jQuery("#site-header").attr("data-flush-header") &&
      jQuery("#PageContainer").addClass("ac"),
    jQuery("#annoucement__bar").hasClass(
      "annoucement__bar--true scroll--false"
    ) &&
      "true" == jQuery("#site-header").attr("data-flush-header") &&
      jQuery("#PageContainer").addClass("ac"),
    jQuery("#annoucement__bar").hasClass(
      "annoucement__bar--true scroll--true"
    ) &&
      "false" == jQuery("#site-header").attr("data-flush-header") &&
      (jQuery("#PageContainer").addClass("ar"),
      jQuery(".header__container").addClass("solid")),
    jQuery("#annoucement__bar").hasClass(
      "annoucement__bar--true scroll--false"
    ) &&
      "false" == jQuery("#site-header").attr("data-flush-header") &&
      (jQuery("#PageContainer").addClass("ar"),
      jQuery(".header__container").addClass("solid")),
    jQuery("#annoucement__bar").hasClass("annoucement__bar--false") &&
      "true" == jQuery("#site-header").attr("data-flush-header") &&
      jQuery("#PageContainer").addClass("pp"),
    jQuery("#annoucement__bar").hasClass("annoucement__bar--false") &&
      "false" == jQuery("#site-header").attr("data-flush-header") &&
      (jQuery("#PageContainer").addClass("ad"),
      jQuery(".header__container").addClass("solid"));
}),
  jQuery(function () {
    var e = jQuery("#site-header");
    jQuery(window).scroll(function () {
      jQuery(window).scrollTop() >= 50
        ? e.removeClass("defaultHeader").addClass("scrolledHeader")
        : e.removeClass("scrolledHeader").addClass("defaultHeader");
    });
  }),
  jQuery(".moveup").click(function () {
    jQuery(".mobile-nav").addClass("menu-mobile-animate");
  }),
  jQuery(".moveout").click(function () {
    jQuery(".mobile-nav").removeClass("menu-mobile-animate");
  }),
  jQuery(".toggle .toggle-title").hasClass("active") &&
    jQuery(".toggle .toggle-title.active")
      .closest(".toggle")
      .find(".toggle-inner")
      .show(),
  jQuery(".toggle .toggle-title").click(function () {
    jQuery(this).hasClass("active")
      ? jQuery(this)
          .removeClass("active")
          .closest(".toggle")
          .find(".toggle-inner")
          .slideUp(200)
      : jQuery(this)
          .addClass("active")
          .closest(".toggle")
          .find(".toggle-inner")
          .slideDown(200);
  }),
  jQuery(function () {
    setTimeout(delayedFragmentTargetOffset, 500);
  });

var cartUpdateDebounce = null;
function debouncedCartUpdate() {
  if (cartUpdateDebounce) {
    clearTimeout(cartUpdateDebounce);
  }
  cartUpdateDebounce = setTimeout(function () {
    jQuery('form.cart button[name="update"]').click();
  }, 800);
}

jQuery(".cart__product-qty").each(function () {
  jQuery(this)
    .wrap(
      jQuery('<span class="cart__product-qty-container">').addClass(
        jQuery(this).hasClass("cart__input-disabled")
          ? "cart__product-qty-container--disabled"
          : ""
      )
    )
    .before(
      jQuery('<button class="cart__product-qty-minus" type="button">')
        .text("-")
        .on("click", function () {
          jQuery(this)
            .next()
            .val(Math.max(0, parseInt(jQuery(this).next().val()) - 1));
          debouncedCartUpdate();
        })
    )
    .after(
      jQuery('<button class="cart__product-qty-plus" type="button">')
        .text("+")
        .on("click", function () {
          jQuery(this)
            .prev()
            .val(parseInt(jQuery(this).prev().val()) + 1);
          debouncedCartUpdate();
        })
    );
});

jQuery(".mobile-site-nav .has-children > a").click(function (e) {
  e.preventDefault();
  jQuery(this).parent().toggleClass("is-open");
});
